var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForcegraphPreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 189,
    viewBox: "0 0 200 189",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 102.857,
    cy: 108.572,
    r: 11.4286,
    fill: "#262C34"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.4286,
    cy: 170.429,
    r: 11.4286,
    fill: "#262C34"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 170.429,
    cy: 158.429,
    r: 11.4286,
    fill: "#262C34"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.429,
    cy: 17.1415,
    r: 11.4286,
    fill: "#262C34"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5721,
    cy: 17.1415,
    r: 11.4286,
    fill: "#262C34"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 61,
    r: 6,
    fill: "#DFE3E5"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 113,
    r: 6,
    fill: "#262C34"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 113,
    r: 6,
    fill: "#262C34"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 58,
    r: 6,
    fill: "#262C34"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 183,
    r: 6,
    fill: "#262C34"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 116,
    r: 6,
    fill: "#262C34"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 102.616,
    y1: 61.5234,
    x2: 102.616,
    y2: 16.1895,
    stroke: "#262C34",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 102.842,
    y1: 55.6821,
    x2: 73.6985,
    y2: 20.0625,
    stroke: "#262C34",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 101.055,
    y1: 57.4969,
    x2: 56.0552,
    y2: 62.4969,
    stroke: "#262C34"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 16.7393,
    y1: 113.573,
    x2: 52.7393,
    y2: 91.5734,
    stroke: "#262C34"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 62.5385,
    y1: 116.192,
    x2: 52.5385,
    y2: 92.1923,
    stroke: "#262C34"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 80.3659,
    y1: 153.659,
    x2: 107.366,
    y2: 182.659,
    stroke: "#262C34"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 148.505,
    y1: 88.9293,
    x2: 152.505,
    y2: 60.9293,
    stroke: "#262C34"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 106.092,
    y1: 54.006,
    x2: 135.236,
    y2: 18.7943,
    stroke: "#262C34",
    strokeWidth: 2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 102.616,
    y1: 103.618,
    x2: 102.616,
    y2: 67.9986,
    stroke: "#262C34",
    strokeWidth: 2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 188.14,
    y1: 75.4225,
    x2: 103.948,
    y2: 104.566,
    stroke: "#262C34",
    strokeWidth: 2
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 101.285,
    y1: 110.514,
    x2: 80.9071,
    y2: 154.421,
    stroke: "#262C34",
    strokeWidth: 2
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 39.5896,
    y1: 171.088,
    x2: 79.5896,
    y2: 153.088,
    stroke: "#262C34",
    strokeWidth: 2
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 96.8926,
    y1: 104.586,
    x2: 9.46278,
    y2: 81.9192,
    stroke: "#262C34",
    strokeWidth: 2
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 130.161,
    y1: 149.545,
    x2: 102.786,
    y2: 107.401,
    stroke: "#262C34",
    strokeWidth: 2
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 131.225,
    y1: 148.026,
    x2: 170.225,
    y2: 157.026,
    stroke: "#262C34",
    strokeWidth: 2
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 188.572,
    cy: 74.285,
    r: 11.4286,
    fill: "#ADB5BD"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.857,
    cy: 11.4286,
    r: 11.4286,
    fill: "#868E96"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.4286,
    cy: 82.6688,
    r: 11.4286,
    fill: "#ADB5BD"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.857,
    cy: 57.1415,
    r: 11.4286,
    fill: "#868E96"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.572,
    cy: 91.4286,
    r: 11.4286,
    fill: "#868E96"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.429,
    cy: 148.572,
    r: 11.4286,
    fill: "#868E96"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.4315,
    cy: 153.899,
    r: 11.4286,
    fill: "#868E96"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.4286,
    cy: 91.4286,
    r: 11.4286,
    fill: "#868E96"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 113,
    r: 6,
    fill: "#ADB5BD"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 62,
    r: 6,
    fill: "#252C34"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForcegraphPreview);
export default __webpack_public_path__ + "static/media/forcegraphPreview.0094737d263d88c748e95d96c8eeb6ad.svg";
export { ForwardRef as ReactComponent };